<template>
  <ToggleSection
    label="Grid Preparation Details (cryo-EM)"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['cryo_tem_grid_model'],
        ['instrument_type', 'grid_prep_instrument'],
        ['gas_mix', 'power'],
        ['glow_time', 'micropatterned'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'GridPreparationCryo',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
